import APIClient from './index';

export const uploadAudioFile = (data) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/ingestion/ingest-audio-only-recording`, data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.data));
  });
};
